import { useState } from 'react';
import {Menu, X, Search, ShieldCheck, Globe, ChevronDown} from 'lucide-react';
import { Link, NavLink } from 'react-router-dom';
import Container from '@/components/ui/Container';
import SearchModal from '@/components/SearchModal';
import { useLanguage } from '@/context/LanguageContext';

const navItems = [
{ key: 'nav.home', to: '/' },
{ key: 'nav.about', to: '/sobre' },
{ key: 'nav.services', to: '/servicos' },
{ key: 'nav.blog', to: '/blog' },
{ key: 'nav.careers', to: '/carreiras' }];


const moreItems = [
{ key: 'nav.resources', to: '/recursos' },
{ key: 'nav.events', to: '/eventos' }];


function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [moreOpen, setMoreOpen] = useState(false);
  const { language, setLanguage, t } = useLanguage();

  const linkClass = ({ isActive }: {isActive: boolean;}) =>
  `text-sm font-medium transition-colors ${isActive ? 'text-cyan-600' : 'text-slate-700 hover:text-cyan-600'}`;

  return (
    <header className="sticky top-0 z-50 w-full border-b border-slate-100 bg-white/95 backdrop-blur-sm">
      <Container className="flex h-20 items-center justify-between">
        <Link to="/" className="flex items-center gap-2 shrink-0" aria-label="FRM Soluções - Página inicial">
          <img
            src="https://static.lumi.new/1f/1ff5ae783ff7274a593125c064bf26df.webp"
            alt="FRM Soluções"
            className="h-16 w-auto mix-blend-multiply"
          />
        </Link>

        <nav className="hidden items-center gap-7 lg:flex" aria-label="Navegação principal">
          {navItems.map((item) =>
          <NavLink key={item.to} to={item.to} className={linkClass}>
              {t(item.key)}
            </NavLink>
          )}
          <div className="relative">
            <button
              type="button"
              onClick={() => setMoreOpen((v) => !v)}
              onBlur={() => setTimeout(() => setMoreOpen(false), 150)}
              className="flex items-center gap-1 text-sm font-medium text-slate-700 hover:text-cyan-600"
              aria-expanded={moreOpen}>

              Mais
              <ChevronDown className="h-4 w-4" aria-hidden="true" />
            </button>
            {moreOpen ?
            <div className="absolute right-0 top-full mt-2 w-44 rounded-xl border border-slate-100 bg-white p-2 shadow-lg">
                {moreItems.map((item) =>
              <Link key={item.to} to={item.to} className="block rounded-lg px-3 py-2 text-sm text-slate-700 hover:bg-slate-50">
                    {t(item.key)}
                  </Link>
              )}
              </div> :
            null}
          </div>
          <NavLink to="/contato" className={linkClass}>
            {t('nav.contact')}
          </NavLink>
        </nav>

        <div className="hidden items-center gap-4 lg:flex">
          <button
            type="button"
            onClick={() => setSearchOpen(true)}
            aria-label="Buscar"
            className="rounded-full p-2 text-slate-500 hover:bg-slate-100 hover:text-slate-700">

            <Search className="h-5 w-5" aria-hidden="true" />
          </button>
          <button
            type="button"
            onClick={() => setLanguage(language === 'pt' ? 'en' : 'pt')}
            className="flex items-center gap-1.5 rounded-full px-2.5 py-1.5 text-sm font-medium text-slate-600 hover:bg-slate-100"
            aria-label="Alternar idioma">

            <Globe className="h-4 w-4" aria-hidden="true" />
            {language === 'pt' ? 'PT' : 'EN'}
          </button>
          <Link
            to="/contato"
            className="rounded-lg bg-cyan-600 px-4 py-2 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-cyan-700">

            {t('nav.cta')}
          </Link>
        </div>

        <div className="flex items-center gap-2 lg:hidden">
          <button type="button" onClick={() => setSearchOpen(true)} aria-label="Buscar" className="rounded-full p-2 text-slate-500 hover:bg-slate-100">
            <Search className="h-5 w-5" aria-hidden="true" />
          </button>
          <button
            type="button"
            onClick={() => setMobileOpen((v) => !v)}
            aria-label={mobileOpen ? 'Fechar menu' : 'Abrir menu'}
            aria-expanded={mobileOpen}
            className="rounded-full p-2 text-slate-700 hover:bg-slate-100">

            {mobileOpen ? <X className="h-6 w-6" aria-hidden="true" /> : <Menu className="h-6 w-6" aria-hidden="true" />}
          </button>
        </div>
      </Container>

      {mobileOpen ?
      <div className="border-t border-slate-100 bg-white lg:hidden">
          <Container className="flex flex-col gap-1 py-4">
            {[...navItems, ...moreItems].map((item) =>
          <NavLink
            key={item.to}
            to={item.to}
            onClick={() => setMobileOpen(false)}
            className={({ isActive }) =>
            `rounded-lg px-3 py-2.5 text-sm font-medium ${isActive ? 'bg-cyan-50 text-cyan-700' : 'text-slate-700 hover:bg-slate-50'}`}>

                {t(item.key)}
              </NavLink>
          )}
            <NavLink
            to="/contato"
            onClick={() => setMobileOpen(false)}
            className="rounded-lg px-3 py-2.5 text-sm font-medium text-slate-700 hover:bg-slate-50">

              {t('nav.contact')}
            </NavLink>
            <Link
            to="/contato"
            onClick={() => setMobileOpen(false)}
            className="mt-2 rounded-lg bg-cyan-600 px-4 py-2.5 text-center text-sm font-semibold text-white hover:bg-cyan-700">

              {t('nav.cta')}
            </Link>
          </Container>
        </div> :
      null}

      <SearchModal open={searchOpen} onClose={() => setSearchOpen(false)} />
    </header>);

}

export default Header;